var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C5 2.23859 7.23859 0 10 0H14C16.7614 0 19 2.23859 19 5V8H16V5C16 3.34314 15 3 14 3H10C9 3 8 3.5 8 5V8H5V5ZM4 9C2.89542 9 2 9.89542 2 11V22C2 23.1046 2.89542 24 4 24H20C21.1046 24 22 23.1046 22 22V11C22 9.89542 21.1046 9 20 9H4ZM7 16C7 18.7614 9.14124 21 11.7826 21C13.1033 21 14.299 20.4404 15.1644 19.5355L13.9347 18.2499C13.3839 18.8257 12.623 19.1818 11.7826 19.1818C10.1017 19.1818 8.73914 17.7573 8.73914 16C8.73914 14.2427 10.1017 12.8182 11.7826 12.8182C13.0757 12.8182 14.1805 13.6613 14.6214 14.8504L13.5217 16H17V12.3636L15.9209 13.4918C15.0928 12.0018 13.5496 11 11.7826 11C9.14124 11 7 13.2386 7 16Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/ChangePassword.f5c3c272a902f4dd387677aea0980977.svg";
export { ForwardRef as ReactComponent };